import React from 'react';
import { motion } from 'framer-motion';
const proof = [{
  value: 'Since 2002',
  note: 'Experience across multiple generations of web technology.',
  tone: 'text-forge-orange'
}, {
  value: '1,000+ websites',
  note: 'Custom builds, rebuilds, ecommerce stores, and long-term client work.',
  tone: 'text-forge-cyan'
}, {
  value: '100+ integrations',
  note: 'CRM, accounting, scheduling, inventory, billing, and other business systems.',
  tone: 'text-forge-orange'
}, {
  value: '0% WebsiteForge transaction fees',
  note: 'Your processor charges its rate. WebsiteForge does not add a percentage of each order.',
  tone: 'text-forge-green'
}];
export function ProofBand() {
  return <section aria-label="Proof points" className="relative overflow-hidden bg-navy-900" data-id="element-207" data-mp="3dv6c1mqqh2gg">
      <div className="absolute inset-0 hatch opacity-[0.3]" aria-hidden="true" data-id="element-208" data-mp="2haxq5kch8zlj" />

      <div className="relative mx-auto grid max-w-8xl grid-cols-1 gap-px bg-white/[0.07] sm:grid-cols-2 lg:grid-cols-4" data-id="element-209" data-mp="2lcj1305gb3t3">
        {proof.map((p, i) => <motion.div key={p.value} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        delay: i * 0.06,
        duration: 0.4
      }} className="bg-navy-900 px-5 py-6 sm:px-7" data-id="element-210" data-mp="qftvj3ybndrn" data-mpi={i}>
            <p className={`font-display text-[17px] font-extrabold leading-tight tracking-[-0.01em] ${p.tone}`} data-id="element-211" data-mp="6pry9j1tcvm9">{p.value}</p>
            <p className="mt-2 text-[13px] leading-relaxed text-mist-300" data-id="element-212" data-mp="2o6ldxpa4hc2">{p.note}</p>
          </motion.div>)}
      </div>
    </section>;
}